<template>
  <v-footer app color="white" class="footer">
    <section class="footer-section app-section-width">
      <div class="button-container">
        <v-tooltip
          v-for="button in buttons"
          :key="button.id"
          top
          :disabled="!authStatus || (isDateAvailable(button.reservationMethod) && isRoomAvailable(button.reservationMethod))"
          max-width=300
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
            >
              <v-btn
                :disabled="authStatus && (!isDateAvailable(button.reservationMethod) || !isRoomAvailable(button.reservationMethod))"
                color="primary lighten-1"
                class="button"
                @click="$emit('startReservation', button.reservationMethod)"
              >
                {{ button.reservationMethod.callToAction }}
              </v-btn>
            </div>
          </template>
          <span>
            {{ tooltipMessage }}
          </span>
        </v-tooltip>
    
        </div>
    </section>
  </v-footer>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'


export default {
  props: {
    buttons: {
      type: Array,
      default: [],
    },
  },
  created () {
    moment.locale(this.$i18n.locale)
  },
  computed: {
    ...mapGetters({
      firstCheckIn: 'me/firstCheckIn',
      lastCheckOut: 'me/lastCheckOut',
      validBookings: 'me/validBookings',
      rooms: 'me/allRooms',
      authStatus: 'auth/authStatus',
    }),
    lastValidDate () {
      return this.validBookings && moment().isBefore(this.lastCheckOut)
        ? moment(this.lastCheckOut)
        : null
    },
    tooltipMessage () {
      return this.isDateAvailable
        ? this.$t('activity_reservation.warning.reservation_method_no_room')
        : !this.validBookings
          ? this.$t('activity_reservation.warning.no_checkin_or_checkout')
          : this.lastValidDate
            ? this.$t('activity_reservation.warning.reservation_method_first_date', {
              date: moment(this.firstValidDate).format('L'),
              hour: moment(this.firstValidDate).format('HH:mm'),
            })
            : this.$t('activity_reservation.warning.no_booking')
    },
  },
  methods: {
    getFirstValidDate (reservationMethod) {
      return this.validBookings
        ? reservationMethod.mustHaveCheckedIn
          ? moment(this.firstCheckIn)
          : moment(this.firstCheckIn).subtract(reservationMethod.leewayBeforeCheckIn, 'ms')
        : null
    },
    isDateAvailable (reservationMethod) {
      return !!this.getFirstValidDate(reservationMethod) && moment().isAfter(this.getFirstValidDate(reservationMethod)) && !!this.lastValidDate
    },
    isRoomAvailable (reservationMethod) {
      if (reservationMethod.type === 'ROOM_SERVICE') {
        return !!this.rooms.length
      }
      return true
    },
  },
}
</script>
<style scoped lang="scss">
.footer {
  box-shadow: 0px -10px 15px 0px rgba(0, 0, 0, 0.05) !important;
}

.footer-section {
  width: 100%;
  padding: 4px;
  margin-right: auto;
  margin-left: auto;
}

.button-container {
  display: flex;
  align-content: space-around;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
}

.button-container > * {
  flex-grow: 1;
}

.button {
  color: white;
  width: 100%;
}
</style>